// ============================================================================
// HINDI TRANSLATIONS - UNITY MODULE
// ============================================================================

export const unityTranslations = {
title: "एकता जो शांति लाती है",
    author: "इमैनुएल द्वारा",
    subtitle: "हर धर्म के अपने कारण हैं, हमारी सीमाएं अतीत से आती हैं",
    description: "आध्यात्मिक एकता और परंपराओं के बीच शांति पर चिंतन मॉड्यूल",
    
    nav: {
      intro: "परिचय",
      religions: "धर्म",
      common: "सामान्य आधार",
      humility: "विनम्रता"
    },

    intro: {
      emmanuelSays: "इमैनुएल कहते हैं:",
      ourBordersFromPast: "हमारी सीमाएं अतीत से आती हैं",
      bordersDescription: "हर धर्म के अपने कारण हैं। हमारे विभाजन दैवीय इच्छा नहीं हैं, बल्कि इतिहास, भूगोल, संस्कृति के फल हैं।",
      divisionWork: "विभाजन, भय की बाधाओं और सीमाओं द्वारा अलगाव, हमारे खतरनाक अतीत का काम है।",
      sharedHumanity: "हम विभिन्न परंपराओं में पैदा हुए, लेकिन हम एक ही मानवता साझा करते हैं।",
      
      revelationTitle: "एक प्रकटीकरण जो आंखें खोलता है",
      surprisedLearning: "मैं एक दिन यह जानकर आश्चर्यचकित हुआ कि यहूदी भी परमेश्वर की संतान हैं।",
      angelMichael: "कि स्वर्गदूत मीकाईल मुसलमानों के लिए एक महान दूत हैं।",
      jesusNames: "कि यीशु, ईसा, येशुआ विभिन्न तरीकों से जाने जाते हैं, यहां तक कि ईसाई विश्वास में भी।",
      diverseTribes: "क्योंकि विभिन्न कबीले हैं, विभिन्न चर्च हैं, विभिन्न परिवार हैं।",
      sameRealities: "हम विभिन्न नामों से समान वास्तविकताओं के बारे में बात करते हैं। यह हमें करीब लाना चाहिए, विभाजित नहीं करना चाहिए।",
      
      respectTitle: "सम्मान: विनम्रता की नींव, शांति का संरक्षक",
      respectFoundation: "भले ही भाईचारा वस्तुनिष्ठ रूप से लागू नहीं हो सकता, सम्मान विनम्रता की नींव है, शांति का संरक्षक।",
      understandingProcess: "अन्य धर्मों को समझना और सम्मान करना विनम्रता की प्रक्रिया है। इसका मतलब अपने विश्वास को त्यागना नहीं है, बल्कि यह स्वीकार करना है कि दूसरे भी सत्य की खोज करते हैं।",
      
      whatBindsUs: "जो वास्तव में हमें बांधता है",
      seekingRelation: "हर धर्म संबंध की तलाश करता है। हर व्यक्ति शांति की तलाश करता है।",
      loveOfGod: "यह संबंध जो हम सभी को बांधता है, परमेश्वर का प्रेम है।",
      universalLink: "प्रेम वह सार्वभौमिक कड़ी है जो सभी सीमाओं, सभी भाषाओं, सभी परंपराओं को पार करती है।",
      
      inclusionTitle: "समावेशन: धार्मिक विविधता से भी अधिक विशाल",
      vastInclusion: "धार्मिक विविधता विशाल है, लेकिन इससे भी अधिक विशाल दूसरों का समावेश है जहां वे परमेश्वर द्वारा बुलाए गए हैं।",
      respectDifferences: "रंग, लिंग के अंतर का सम्मान, समावेशन हमें अनोखे मनुष्य बनाता है, परमेश्वर द्वारा प्रिय।",
      jesusCommand: "यीशु ने कहा: 'एक दूसरे से प्रेम करो।'",
      
      communitySpirit: "सांप्रदायिक भावना से विच्छेद",
      communityTerror: "सांप्रदायिकता बुराई की छिपी हुई घृणा का आतंक है। यह विश्वास को आदिवासी पहचान में बदल देती है, एक दीवार में जो अलग करती है, एक हथियार में जो घायल करती है।",
      pridePolitics: "हमारी दलीय भावनाएं हमें अभिमान की राजनीति की ओर धकेलती हैं:",
      prideQuotes: "मुझे आपको नुकसान पहुंचाने का अधिकार है। मेरा अधिकार है बस। मुझे अच्छा युद्ध करने का अधिकार है।",
      watchHeart: "समस्या के मूल से सावधान रहें, हमारी अपनी बुराई की जड़ से।",
      refuseDivision: "आइए हम इस बहाव को अस्वीकार करें जो परमेश्वर के नाम पर मानवता को विभाजित करता है।",
      
      freedomTitle: "स्वतंत्र होने के लिए, दूसरों को स्वतंत्र बनाएं",
      freedomOthers: "स्वतंत्र होने के लिए, हमें दूसरों को भी स्वतंत्र बनाना जानना चाहिए।",
      defendFreedom: "मेरी विश्वास की स्वतंत्रता तभी मूल्यवान है जब मैं सभी की रक्षा करूं। दूसरों का उत्पीड़न करना खुद को दासता के लिए दोषी ठहराना है।",
      
      changeHeartTitle: "अपना दिल बदलें: एक सच्ची लालटेन बनें",
      recognizeDecency: "पहचानें कि शालीनता हर किसी के लिए समान नहीं है।",
      changeYourself: "पहले खुद को बदलें, धीरे-धीरे। अपना दिल बदलें, अपने जीवन को रूपांतरित करें, एक सच्ची लालटेन बनें।",
      beExample: "आप घास पर पेशाब नहीं करेंगे, क्योंकि यह मर जाएगी... दूसरों पर अपने नियम थोपें नहीं, बल्कि अपने परिवर्तन के माध्यम से एक जीवित उदाहरण बनें।",
      
      childrenPeaceTitle: "हमारे बच्चे विविधता में शांति से रहेंगे",
      avoidPursuit: "शब्दों के लिए शब्दों का पीछा करने से बचें।",
      peaceChoice: "यदि हम आज सम्मान चुनते हैं, तो भविष्य के हमारे बच्चे विविधता में शांति से रहेंगे। शांति हमसे शुरू होती है, अब, हमारे शब्दों और कार्यों में।",
      
      discernTitle: "विवेक करें: मनुष्य या परमेश्वर?",
      manSpeaks: "अक्सर, यह मनुष्य का दिल है जो बोलता है और विभाजित करता है।",
      seeFruits: "हम इसे शब्दों और कथनों के फल से देखते हैं: चोरी, विनाश, युद्ध। अपने अभिमान के लिए प्रतिस्पर्धा करने के लिए शब्दों के हेरफेर से सावधान रहें।",
      
      lookPeaceTitle: "शांति और प्रेम की ओर देखें",
      lookPeaceAll: "सभी के लिए शांति की ओर देखें, दूसरों के लिए परमेश्वर के प्रेम की ओर देखें।",
      godSpeaks: "जब शब्द शांति, सुलह, एकता उत्पन्न करते हैं: यह परमेश्वर बोल रहा है। जब वे विभाजन, घृणा, युद्ध उत्पन्न करते हैं: यह मनुष्य का अभिमान है।",
      
      watchWordsTitle: "हमारे शब्दों पर ध्यान दें",
      watchShares: "हमारे साझाकरण पर ध्यान दें, दूसरों के प्रति हमारे हानिकारक विपरीत शब्दों पर ध्यान दें।",
      disqualify: "ये बुराइयां हमें अयोग्य ठहराती हैं। हमारे शब्दों के फल प्रकट करते हैं कि हममें कौन बोल रहा है: परमेश्वर या हमारा अपना अभिमान?",
      
      wisdomMaturityTitle: "हमारे स्वभाव के सामने बुद्धि और परिपक्वता",
      useScriptures: "नुकसान पहुंचाने के लिए धर्मग्रंथों (कानूनों) का उपयोग करना हमारी आदत है, एक लगभग प्राकृतिक और शरारती प्रक्रिया।",
      hateSin: "हमारे पापपूर्ण स्वभाव के सामने, हम बुराई और बुराई करने वाले लोगों से घृणा करते हैं।",
      separateActs: "लेकिन बुद्धि और परिपक्वता के माध्यम से, हमें कार्यों को हमारी मानवीय गरीबी से अलग करना चाहिए।",
      compassionNature: "हमारे पशु स्वभाव को पहचानें जिसे करुणा और अनुग्रह की आवश्यकता है, जबकि संदर्भ के अनुसार खुद को सुरक्षित रखना।",
      
      denounceLeadersTitle: "भ्रष्ट आध्यात्मिक नेताओं की निंदा करें",
      watchLeaders: "आध्यात्मिक नेताओं या शासकों से सावधान रहें जो अपने विचलन और बेईमानी को गुप्त रखने की कोशिश करते हैं।",
      noJustice: "न्याय के बिना, कोई उदाहरण नहीं। ज्ञान के बिना, अन्य पीड़ित हमारी चुप्पी से मर जाते हैं।",
      silenceComplicity: "अन्याय के सामने चुप्पी साझेदारी है। दूसरों की रक्षा के लिए सच्चाई कही जानी चाहिए।"
    },

    religions: {
      title: "विविध धर्म, एक मानवता",
      intro: "ईसाई, मुसलमान, यहूदी, हिंदू, बौद्ध... और कई अन्य: सभी सत्य की तलाश करते हैं",
      theirGod: "उनके भगवान:",
      theGood: "भलाई:",
      theEvil: "बुराई:",
      theAngels: "स्वर्गदूत:",
      theUnity: "एकता:",
      values: "मूल्य:",
    commonGoal: "साझा लक्ष्य",
    seekingPeace: "सभी धर्म एक साझा लक्ष्य साझा करते हैं: शांति की तलाश करना, प्रेम को बढ़ावा देना और एक बेहतर दुनिया बनाना। हमारे मतभेदों से परे, हम सभी इस ज्ञान और सद्भाव की खोज में एकजुट हैं।",
      
      christianity: {
        name: "ईसाई धर्म",
        godText: "एक अद्वितीय परमेश्वर, पिता सृष्टिकर्ता",
        goodText: "पड़ोसी का प्यार, क्षमा, शांति",
        evilText: "घृणा, स्वार्थ, हिंसा",
        angelsText: "परमेश्वर के दूत (गब्रिएल, मीकाईल...)",
        unityText: "सभी मनुष्यों के लिए एक परमेश्वर",
        values: "प्रेम,क्षमा,शांति,विनम्रता,न्याय"
      },
      islam: {
        name: "इस्लाम",
        godText: "अल्लाह, एकमात्र और दयालु",
        goodText: "न्याय, दान, शांति",
        evilText: "उत्पीड़न, झूठ, विभाजन",
        angelsText: "प्रकाश के स्वर्गदूत (जिब्रील, मिकाइल...)",
        unityText: "अल्लाह के अलावा कोई भगवान नहीं",
        values: "शांति,न्याय,दान,सम्मान,दया"
      },
      judaism: {
        name: "यहूदी धर्म",
        godText: "यहोवा, शाश्वत अद्वितीय",
        goodText: "न्याय, करुणा, जीवन",
        evilText: "उत्पीड़न, निंदा, घृणा",
        angelsText: "स्वर्गीय दूत (मलाखिम)",
        unityText: "सुनो इस्राएल, शाश्वत एक है",
        values: "न्याय,जीवन,स्मृति,शांति,अध्ययन"
      },
      hinduism: {
        name: "हिंदू धर्म",
        godText: "ब्रह्म, परम सत्य",
        goodText: "अहिंसा, धर्मयुक्त कर्तव्य",
        evilText: "हिंसा, आध्यात्मिक अज्ञानता",
        angelsText: "देव, परोपकारी स्वर्गीय प्राणी",
        unityText: "ब्रह्म में सब एक है",
        values: "अहिंसा,सत्य,करुणा,शुद्धता,सामंजस्य"
      },
      buddhism: {
        name: "बौद्ध धर्म",
        godText: "कोई सृष्टिकर्ता भगवान नहीं, लेकिन पवित्र का सम्मान",
        goodText: "करुणा, बुद्धि, शांति",
        evilText: "अज्ञानता के कारण पीड़ा",
        angelsText: "बोधिसत्व, जागृत प्राणी",
        unityText: "प्रत्येक में बुद्ध प्रकृति",
        values: "करुणा,बुद्धि,शांति,अहिंसा,जागृति"
      }
    },

    common: {
      title: "सामान्य आधार",
      intro: "भलाई, बुराई, स्वर्गदूत, एक परमेश्वर, संबंध, समावेशन: जो मानवता को एकजुट करता है",
      
      goodTitle: "भलाई",
      goodDescription: "सभी धर्म प्रेम, न्याय और करुणा सिखाते हैं",
      goodExamples: "अपने पड़ोसी से अपने समान प्यार करो|बिना भेदभाव के भलाई करो|कमजोर और उत्पीड़ित की रक्षा करो|दयालुता से सच बोलो|जो तुम्हारे पास है उसे साझा करो",
      
      evilTitle: "बुराई",
      evilDescription: "सभी हिंसा, झूठ और उत्पीड़न की निंदा करते हैं",
      evilExamples: "न्याय के बिना मारना|चोरी करना और शोषण करना|झूठ बोलना और निंदा करना|तिरस्कार करना और अपमान करना|विभाजित करना और घृणा करना",
      
      angelsTitle: "स्वर्गदूत और आध्यात्मिक प्राणी",
      angelsDescription: "लगभग सभी परोपकारी स्वर्गीय दूतों को मान्यता देते हैं",
      angelsExamples: "परमेश्वर के दूत स्वर्गदूत|आध्यात्मिक मार्गदर्शक|प्रकाश के प्राणी|स्वर्गीय संरक्षक|बोधिसत्व और देव",
      
      godTitle: "एक परमेश्वर (या परम वास्तविकता)",
      godDescription: "अधिकांश एक स्रोत, एक निर्माता या परम वास्तविकता में विश्वास करते हैं",
      godExamples: "ईसाई धर्म, इस्लाम, यहूदी धर्म: एक परमेश्वर|हिंदू धर्म: ब्रह्म, परम एक|बौद्ध धर्म: सार्वभौमिक बुद्ध प्रकृति|सभी परम सत्य की तलाश करते हैं|सभी एकता और शांति की आकांक्षा रखते हैं",
      
      relationTitle: "संबंध और शांति",
      relationDescription: "जो वास्तव में सभी धर्मों और सभी मनुष्यों को एकजुट करता है",
      relationExamples: "हर धर्म दिव्य के साथ संबंध की तलाश करता है|हर व्यक्ति शांति की तलाश करता है|यह संबंध जो हम सभी को बांधता है, परमेश्वर का प्रेम है|प्रेम सार्वभौमिक कड़ी है|शांति हमारी सामान्य आकांक्षा है",
      
      inclusionTitle: "समावेशन: परमेश्वर द्वारा प्रिय",
      inclusionDescription: "धार्मिक विविधता विशाल है, लेकिन समावेशन और भी अधिक विशाल है",
      inclusionExamples: "दूसरों का समावेश जहां वे परमेश्वर द्वारा बुलाए गए हैं|रंग के अंतर का सम्मान|लिंग के अंतर का सम्मान|समावेशन हमें अनोखे मनुष्य बनाता है, परमेश्वर द्वारा प्रिय|यीशु ने कहा: 'एक दूसरे से प्रेम करो'",
      
      finalQuote: "मैं एक दिन यह जानकर आश्चर्यचकित हुआ कि यहूदी भी परमेश्वर की संतान हैं, कि स्वर्गदूत मीकाईल मुसलमानों के लिए एक महान दूत हैं, कि यीशु, ईसा, येशुआ विभिन्न तरीकों से जाने जाते हैं, यहां तक कि ईसाई विश्वास में भी। क्योंकि विभिन्न कबीले हैं, विभिन्न चर्च हैं, विभिन्न परिवार हैं।",
      finalQuote2: "हम विभिन्न नामों से समान वास्तविकताओं के बारे में बात करते हैं।",
      quoteAuthor: "इमैनुएल, एकता जो शांति लाती है"
    },

    humility: {
      title: "विनम्रता और शांति की ओर 7 कदम",
      intro: "सांप्रदायिकता को पार करने और एक सच्ची लालटेन बनने की प्रक्रिया",
      
      step: "कदम",
      action: "कार्य:",
      
      step1Title: "पहचानें: हमारी सीमाएं अतीत से आती हैं",
      step1Description: "विभाजन, भय की बाधाओं और सीमाओं द्वारा अलगाव, हमारे खतरनाक अतीत का काम है। हमारे विभाजन परमेश्वर की इच्छा नहीं हैं।",
      step1Action: "स्वीकार करें कि मेरी परंपरा केवल मेरी है, और मैं परमेश्वर द्वारा वांछित विविधता का हिस्सा हूं",
      
      step2Title: "सम्मान: विनम्रता की नींव, शांति का संरक्षक",
      step2Description: "भले ही भाईचारा वस्तुनिष्ठ रूप से लागू नहीं हो सकता, सम्मान नींव है।",
      step2Action: "सभी विश्वासों का सम्मान करें, भले ही सब कुछ न समझें",
      
      step3Title: "बिना न्याय के समझें",
      step3Description: "आज, दूसरों को समझना विनम्रता की एक आवश्यक प्रक्रिया है।",
      step3Action: "वास्तव में सुनें कि दूसरे क्या मानते हैं, बिना न्याय के",
      
      step4Title: "पहले खुद को बदलें: एक सच्ची लालटेन बनें",
      step4Description: "पहचानें कि शालीनता हर किसी के लिए समान नहीं है। अपना दिल धीरे-धीरे बदलें, अपने जीवन को रूपांतरित करें, एक सच्ची रोशनी बनें।",
      step4Action: "दूसरों पर मेरे नियम थोपने के बजाय, अपने परिवर्तन के माध्यम से एक जीवित उदाहरण बनें",
      
      step5Title: "सांप्रदायिक भावना से विच्छेद",
      step5Description: "हमारी दलीय भावनाएं हमें अभिमान की राजनीति की ओर धकेलती हैं: 'मुझे आपको नुकसान पहुंचाने का अधिकार है, मेरा अधिकार है बस।' समस्या के मूल से सावधान रहें, हमारी अपनी बुराई की जड़ से।",
      step5Action: "अपने समुदाय में विभाजनकारी भाषणों को अस्वीकार करें",
      
      step6Title: "स्वतंत्र होने के लिए, दूसरों को स्वतंत्र बनाएं",
      step6Description: "मेरी स्वतंत्रता उस पर निर्भर करती है जो मैं दूसरों को देता हूं।",
      step6Action: "सभी की अंतरात्मा की स्वतंत्रता की रक्षा करें, केवल मेरी नहीं",
      
      step7Title: "शब्दों के लिए शब्दों का पीछा करने से बचें",
      step7Description: "घृणा का जवाब घृणा से, अपमान का जवाब अपमान से न दें।",
      step7Action: "शांति चुनें ताकि हमारे बच्चे विविधता में शांति से रहें",
      
      discernFruits: "फलों से विवेक करें",
      humanHeart: "मनुष्य का दिल जो विभाजित करता है",
      lookGodLove: "परमेश्वर के प्रेम की ओर देखें",
      watchOurWords: "हमारे शब्दों पर ध्यान दें",
      
      prideFruits: "मानव अभिमान के फल",
      prideFruitsList: "दलीय भावना: \"मैं सही हूं, बस\"|अहंकार की राजनीति: \"मुझे तुम्हें चोट पहुंचाने का अधिकार है\"|धर्मग्रंथों का उपयोग चोट पहुंचाने के लिए (शरारती प्रक्रिया)|व्यक्तियों से नफरत करना (केवल कृत्यों से नहीं)|आध्यात्मिक नेता जो अपनी विचलन और बेईमानी छिपाते हैं|अन्याय के सामने सहयोगी मौन|विभाजन और युद्ध|धर्मपरायणता के रूप में छिपी नफरत|चोरी और विनाश|अहंकार के लिए हेरफेर|तिरस्कार और हिंसा",
      
      godFruits: "परमेश्वर के प्रेम के फल",
      godFruitsList: "बुद्धिमानी से कृत्यों को व्यक्ति से अलग करना|हमारी मानवीय गरीबी के प्रति करुणा|संदर्भों के अनुसार खुद को बचाते हुए कृपा|दूसरों की रक्षा के लिए अन्याय की निंदा करना|साहस के साथ सच बोलना|सभी के लिए शांति|बिना भेदभाव का प्यार|सुलह और एकता|विनम्रता और सम्मान|सभी के लिए स्वतंत्रता",
      
      finalQuote: "भले ही भाईचारा वस्तुनिष्ठ रूप से लागू नहीं हो सकता, सम्मान विनम्रता की नींव है, शांति का संरक्षक। शब्दों के लिए शब्दों का पीछा करने से बचें, और भविष्य के हमारे बच्चे विविधता में शांति से रहेंगे।",
      author: "इमैनुएल"
    },

    footer: {
      quote: "सम्मान विनम्रता की नींव है, शांति का संरक्षक। हमारे बच्चे विविधता में शांति से रहेंगे यदि हम आज सम्मान चुनते हैं।",
      author: "इमैनुएल, एकता जो शांति लाती है"
    }
};

export default unityTranslations;
